import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import styles from './Grid.module.scss'

export const Col = ({ children, size = 12, offset, className, dataTestId }) => {
  const classNamesList = classNames(
    styles.gridColumn,
    {
      [styles[`size-${size}`]]: size,
      [styles[`offset-${offset}`]]: offset,
    },
    className,
  )

  return (
    <div data-test-id={dataTestId} className={classNamesList}>
      {children}
    </div>
  )
}

Col.propTypes = {
  children: PropTypes.node,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  size: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  offset: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]),
  dataTestId: PropTypes.string,
}
